
var currentimageid;

var imageidparam;

var imageshost = "https://cdn.drawaria.online/file/drawariaonline-galleryimages/"; // "//galleryhost." + location.hostname.split(".").slice(-2).join(".") + "/gallery/images/";  "https://drawariaonline-galleryimages.s3.us-west-002.backblazeb2.com/";

$(function() {
	location.queryString = {};
	location.search.substr(1).split("&").forEach(function (pair) {
		if (pair === "") return;
		var parts = pair.split("=");
		location.queryString[parts[0]] = parts[1] &&
			decodeURIComponent(parts[1].replace(/\+/g, " "));
	});
	
	
	try {
		if( location.hostname.indexOf("test") != -1 ){
			imageshost = location.origin + "/gallery/images/";
		}
		
		if( navigator.userAgent.indexOf('Windows NT 5.1') != -1 ){
			imageshost = "https://galleryhost2.drawaria.online/gallery/images/";
		}
	} catch(err) {}
	
	var sortparam = (window.location.pathname.match(/\/(new|top|hot|picks)/) || ["", "hot"])[1];

	imageidparam = (window.location.pathname.match(/\/img\/(\d+)/) || [])[1];
	if( imageidparam ){
		
		$("#uploadtip").hide();
		$(".filtercontainer > select").hide();
		
		$.getJSON("/gallery/getimages/", {
			"imageid": imageidparam
		}, function( arr ) {
			if( arr.length == 0 )
				return;
			
			var imagedata = arr[0];
			
			if( imagedata.deletedflag && (!imagedata.accplayernames || imagedata.accplayernames.length == 0) )
				return;
			
			if( imagedata.deletedflag && location.queryString.uid == imagedata.uid )
				return;
			
			if( imagedata.deletedbymod && window.ACCOUNTUID != imagedata.uid && !location.queryString.deletedbymod )
				return;
			
			$("#viewimage .playername").html(getplayernames_rand(imagedata));
			
			$("#viewimage .uploaddate").html(new Date(imagedata.created).toLocaleDateString());
			
			var arr1 = [];
			[["stencils", "Stencils"], ["pixelart", "Pixel Art"], ["advtools", "Algorithmic Tools"]].forEach(v => {
				if( imagedata[v[0]] ){
					arr1.push(v[1])
				}
			});
			
			$("#viewimage .modeflags").html(arr1.join(", "));
			
			$("#viewimage .ratingbutton:eq(0) a").click(function(){rateimage(event, imageidparam, 1)});
			$("#viewimage .ratingbutton:eq(1) a").click(function(){rateimage(event, imageidparam, 2)});
			
			$("#viewimage .ratingbutton:eq(0) span").text(imagedata.rating1 || "");
			$("#viewimage .ratingbutton:eq(1) span").text("");
			
			if( localstorage_get(`r${imagedata.id}`) ){
				$(`#viewimage .ratingbutton:eq(${localstorage_get(`r${imagedata.id}`) - 1})`).addClass("ratingbutton-voted");
			}
			
			$("#viewimage img")
				.attr("src", imageshost + imageidparam + ".jpg")
				.click(viewimage);

			$("#viewimage")
				.data("imageid", imageidparam)
				.show();
			
			details_init(imageidparam, imagedata.accplayernamesobj, window.ACCOUNTUID, window.CANDELETEIMAGES);
			
			$("#viewimage").append(`<div id="comments-container"></div>`);
			$.getScript("/pageres/comments.js", () => {
				if( window.loadcomments ){
					window.loadcomments($, 1, imageidparam, imagedata.accplayernamesobj, window.ACCOUNTUID, window.CANDELETEIMAGES);
				}
			});
			
		});
		
		return;
	}
	
	$(`[href*='/gallery/${sortparam}/']`).addClass("active");
	
	var grid = $(".grid");
	
	var masonry = new Masonry('.grid', {
		itemSelector: '.grid-item',
		columnWidth: '.masonry-columnwidth',
		gutter: '.masonry-gutter',
		percentPosition: true,
		stagger: 30,
		visibleStyle: { transform: 'translateY(0)', opacity: 1 },
		hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
	});
	
	var infscroll = new InfiniteScroll('.grid', {
		path: function(){
			return `/gallery/getimages?page=${this.loadCount}&uid=${location.queryString.uid || ""}&imageid=${location.queryString.image || ""}&sort=${sortparam}&modefilter=${location.queryString.filter || ""}`;
		},
		responseType: 'json',
		outlayer: masonry,
		status: '.page-load-status',
		history: false,
	});

	grid.on('load.infiniteScroll', (event, imagesdata) => {
		
		if( !imagesdata ){
			
			return;
		}
	
		if( imagesdata.length == 0 ){
			infscroll.destroy();
			
			return;
		}
		
		var htmlstr = "";
		for( const v of imagesdata ){
			
			if( v.deletedflag && (!v.accplayernames || v.accplayernames.length == 0) )
				continue;
			
			if( v.deletedflag && location.queryString.uid == v.uid )
				continue;
			
			if( v.deletedbymod && (ACCOUNTUID != v.uid || location.queryString.uid != v.uid) && !location.queryString.deletedbymod )
				continue;
			
			if( window.CANDELETEIMAGES && location.queryString.deletedbymod && !v.deletedbymod )
				continue;
			
			var rated = localstorage_get(`r${v.id}`);
			
			htmlstr += `
			<div class="grid-item galleryimage ${v.deletedbymod && !location.queryString.deletedbymod ? "deletedbymod" : ""}" onclick="viewimage(event)" data-imageid="${v.id}">
				<img src="${imageshost}${v.id}s.jpg" />
				<div class="info info-u">
				<span style="float:right" class="modmenu"></span>
				<span class="imglink"><a href="/gallery/img/${v.id}" target="_blank"><i class="fas fa-external-link-square-alt"></i></a></span>
				<div class="playername">${location.queryString.uid ? getplayernames(v) : getplayernames_rand(v)}</div>
				<div class="uploaddate">${new Date(v.created).toLocaleDateString()}</div>
				<div class="title">${v.targetword || v.title || ""}</div>
				</div>
				<div class="info info-l" style="">
				<span class="imagerating">
				<span class="ratingbutton ${rated == 1 ? "ratingbutton-voted" : ""}"><a href="javascript:void(0);" onclick="rateimage(event, ${v.id}, 1);"><i class="far fa-thumbs-up"></i><span>${v.rating1 || ""}</span></a></span>
				<span class="ratingbutton ${rated == 2 ? "ratingbutton-voted" : ""}"><a href="javascript:void(0);" onclick="rateimage(event, ${v.id}, 2);"><i class="far fa-thumbs-down"></i><span></span>${""}</a></span>
				</span>
				<span class="comments"><a href="/gallery/img/${v.id}/#comments" target="_blank"><i class="far fa-comment-dots ${!v.comments && !window.ACCOUNTUID ? "d-none" : ""}">${v.comments || ""}</i></a></span>
				<a href="javascript:void(0);" onclick="deleteimage(event, ${v.id});" class="deleteimage" style="${(window.ACCOUNTUID == location.queryString.uid && (window.ACCOUNTUID == v.uid || v.accplayernamesobj[window.ACCOUNTUID])) ? "" : "display: none;"}"><i class="fas fa-trash-alt"></i><i class="fas fa-question confirmicon" style="display: none; margin-left: 0.2em;"></i></a>
				</div>
			</div>`
		}
		 
		var items = $(htmlstr);
		items.imagesLoaded( function() {
			infscroll.appendItems(items);
			masonry.appended(items);
			
			if( grid.outerHeight() < $(window).outerHeight() ){
				infscroll.loadNextPage();
			}
		});
	  
		items.find(".deleteimage").focusout(function(event){
			if( $(this).data("confirmflag") ){
				$(this).data("confirmflag", false);
				$(this).find(".confirmicon").hide();
			}
		})
	  
	  	if( window.CANADDPICKS || window.SHOWADMINACTIONS || window.CANDELETEIMAGES ){
			items.find(".modmenu").html(`<div class="dropdown">
			  <button class="btn btn-outline-secondary btn-sm" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<i class="fas fa-bars"></i>
			  </button>
			  <div class="dropdown-menu">
				<button type="button" class="btn dropdown-item" data-action="addtopicks">Add to Community Picks</button>
				<button type="button" class="btn dropdown-item" data-action="passfilter">Do not filter out</button>
				<button type="button" class="btn dropdown-item" data-action="removefrompicks" style="${window.SHOWADMINACTIONS && sortparam == "picks" ? "" : "display:none;"}">Remove from Commutiny Picks</button>
				<div class="dropdown-divider"></div>
				<button type="button" class="btn dropdown-item" data-action="deleteimage" style="${window.CANDELETEIMAGES && !location.queryString.deletedbymod ? "" : "display:none;"}">Delete Image</button>
				<button type="button" class="btn dropdown-item" data-action="restoreimage" style="${window.SHOWADMINACTIONS && location.queryString.deletedbymod ? "" : "display:none;"}">Restore Image</button>
				<div class="dropdown-divider" style="${window.SHOWADMINACTIONS ? "" : "display:none;"}"></div>
				<button type="button" class="btn dropdown-item" data-action="galleryban" style="${window.SHOWADMINACTIONS ? "" : "display:none;"}">Delete and Ban Uploader</button>
			  </div>
			</div>`);
			
			items.find(".modmenu [data-toggle=dropdown]").dropdown();
			items.find(".dropdown-menu").on("click", ".dropdown-item", modmenuclick);
		}
		
	  
	});

	$(".filtercontainer > select").change(function(event){
		var s = location.search.replace(/filter=\w+\&?/, "") || "?";
		if( $(".filtercontainer > select").val() != 0 ){
			s += (s.length > 1 && s.substr(-1) != "&" ? "&" : "") + "filter=" + $(".filtercontainer > select").val();
		}
		window.location.href = window.location.origin + window.location.pathname + s.replace(/[?&]$/, "");
	})
	
	if( location.queryString.filter ){
		$(".filtercontainer > select").val(location.queryString.filter);
	}

	$(window).on("popstate", function () {
		try {
			if( history.state && history.state["name"] == "viewimage" ){
				window.viewimage({"target": $(`.galleryimage[data-imageid=${history.state["imageid"]}] > img`)[0]})
			} else {
				window.gallery.close();
			}
		} catch(err) {}
		
	});
	
	$(".grid").on("mousedown", ".grid-item > img", function(event){
		if( event.which == 2 ){
			event.preventDefault();
			event.stopPropagation();
			
			window.open("/gallery/img/" + $(this).closest(".galleryimage").data("imageid"), "_blank");
		}
	});
	
	function details_init(imageid, imageowners, uidloggedin, havemodperms){
		var ownimage = imageowners[uidloggedin];
		
		if( ownimage ){
			$('head').append(`
				<script src="/3rd/lib/tagify/tagify.min.js"></script>
				<script src="/3rd/lib/tagify/tagify.polyfills.min.js"></script>
				<link href="/3rd/lib/tagify/tagify.css" rel="stylesheet" type="text/css" />
			`);
		}
		
		$("#viewimage").append(`<div id="details-container"></div>`);
		
		$("#details-container").on("click", ".dropdown-item", function(event){
			event.preventDefault();
			
			var el = $(this);
			
			var elcard = el.closest(".details-card");
			
			var uid = elcard.data("uid");
			
			if( el.data("action") == "edit" ){
				details_showinput(uid, imageid);
			} else if( el.data("action") == "delete" ){
				if( uidloggedin != uid && havemodperms ){
					details_send({imageid, "action": "modremovedetails", uid})
					.then(noerror => {
						if( noerror ){
							elcard.remove();
						}
					});
				} else {
					details_send({imageid, "action": "removedetails"})
					.then(noerror => {
						if( noerror ){
							elcard.remove();
						}
					});
				}
			}
		});
		
		$.getJSON("/gallery/getimagedetails", {
			imageid
		}, (loadedarr) => {
			if( !loadedarr ){
				
				return;
			}
			
			containerhtml = "";
			
			var createcard = (obj, uidnew) => {
				var datavalue = "";
				
				if( uidnew ){
					obj = {
						"uid": uidnew
					}
					
				}
				
				var {uid, title, descr, tags} = obj;
				
				if( imageowners[uid] == null || (!ownimage && !uidnew && !title && !descr && !tags) ){
					
					return "";
				}
				
				if( tags ){
					try {
						tags = details_preparetags(JSON.parse(tags));
					} catch(err) {
						tags = "<error>";
					}
				}
				
				var menustr = "";
				
				if( (ownimage && uidloggedin == uid) || havemodperms ){
					menustr = `
						<div class="dropdown details-cardmenu">
						<button class="btn btn-link btn-sm" type="button" data-toggle="dropdown"><i class="fas fa-ellipsis-v"></i></button>
						<div class="dropdown-menu dropdown-menu-right">
							<a class="dropdown-item ${uidloggedin != uid ? "disabled" : ""}" data-action="edit" href="#" data-sortby="0">Edit Card</a>
							<div class="dropdown-divider"></div>
							<a class="dropdown-item" data-action="delete" href="#" data-sortby="0">Delete Card</a>
						  </div>
						</div>
					`;
				}
				
				return `
					<div class="card details-card" data-uid=${uid}>
					<div class="card-body">
					<a href="/profile/?uid=${uid}"><img src="/avatar/cache/${uid}.jpg"><span>${imageowners[uid]}</span></a>
					
					<div class="details-card-inner">
					<div class="details-content">
					<div class="details-title"><span>${title || ""}</span></div>
					<div class="details-expander-container"><div class="details-descr"><span>${descr || ""}</span></div></div>
					<div class="btn btn-link details-expander-button" style="display: none;">Show more...</div>
					<div class="details-tags">${tags || ""}</div>
					</div>
					<div class="details-inputcontainer" style="display:none;"></div>
					</div>
					
					</div>
					${menustr}
					</div>
				`
			}
			
			containerhtml += `<div class="details-editmessage" style="display: none;s">Add info to this image...</div>`;
			
			if( loadedarr.length > 1 ){
				$("#details-container").addClass("details-grid");
			}
			
			shuffleArray(loadedarr);
			
			if( ownimage ){
				var idxself = loadedarr.findIndex(v => v.uid == uidloggedin);
				
				if( idxself != -1 ){
					containerhtml += createcard(loadedarr[idxself]);
					loadedarr.splice(idxself, 1);
				} else {
					containerhtml += createcard(null, uidloggedin);
					if( loadedarr.length < 1 ){
						var details_timer = setInterval(() => {
							if( !window.Tagify )
								return;
							
							clearInterval(details_timer);			
							
							details_showinput(uidloggedin, imageid);
						}, 500);
					}
				}
			}
			
			loadedarr.forEach((v) => {
				containerhtml += createcard(v);
			});
			
			$("#details-container").html(containerhtml);
			
			details_showexpanders();
			
			$(".details-expander-button").click(function(event){
				$(this).closest(".details-card").find(".details-expander-container").removeClass("details-expander-container");
				$(this).closest(".details-card").find(".details-expander-button").hide();
			});
			
			$("#details-container").find(".details-editmessage").click(function(event){
				details_showinput(uidloggedin, imageid);
			});
			
			if( ownimage ){
				details_showeditmessage(uidloggedin);
			}
		})
	}
	
	var details_tagstimer;
	
	function details_showinput(uid, imageid){
		
		var resetfield = (fieldname) => {
			inputcontainer.find(`[name="${fieldname}"]`).val(inputcontainer.closest(".details-card").find(`.details-content .details-${fieldname}`).text());
		}
		
		var containerhtml = `
			<div class="form-group" data-name="title">
			
			<div class="input-group datails-savebuttons details-buttonshidden">
			<input type="text" name="title" class="form-control" placeholder="Title" maxlength="100" required>
			<div class="input-group-append">
			<button class="btn btn-primary savebutton" type="button"><i class="fas fa-check fa-fw"></i></button>
			<button class="btn btn-outline-secondary abortbutton" type="button"><i class="fas fa-times fa-fw"></i></button>
			</div>
			</div>
			
			</div>
			<div class="form-group" data-name="descr">
			<div class="input-group datails-savebuttons details-buttonshidden">
			<textarea name="descr" class="form-control" rows="3" placeholder="Description"  maxlength="1000"></textarea>
			<div class="input-group-append">
			<button class="btn btn-primary savebutton" type="button"><i class="fas fa-check fa-fw"></i></button>
			<button class="btn btn-outline-secondary abortbutton" type="button"><i class="fas fa-times fa-fw"></i></button>
			</div>
			</div>
			
			</div>
			<div class="form-group">
			<input name="tags" class="details-input-tags"  placeholder="Tags"  maxlength="30">
			</div>
			<button type="button" class="btn btn-outline-info btn-sm details-exitbutton">Exit editing</button>
		`;
		
		var elcard = $(`#details-container .details-card[data-uid=${uid}]`);
		
		elcard.show();
		
		elcard.addClass("details-editenabled");
		elcard.find(".details-content").hide();
		elcard.find(".details-inputcontainer")
			.show()
			.html(containerhtml);
		
		var inputcontainer = elcard.find(".details-inputcontainer");
		
		inputcontainer.find(".datails-savebuttons").on("input", function(event){
			$(this).closest(".input-group").removeClass("details-buttonshidden");
		});
		
		inputcontainer.find(".datails-savebuttons .savebutton").on("click", function(event){
			var el = $(this).closest("[data-name]");
			var name = el.data("name");
			var val = el.find("[name]").val();
			
			val = val.replace(/\s{3,}/, (m) => {
				return m.charAt(0);
			});
			
			val = val.replace(/[\p{Z}\p{C}\p{Cf}]+/u, " ").trim();
			
			el.find("[name]").val(val);
			
			elcard.addClass("details-card-disabled");
			details_send({imageid, "action": "setdetails", "fieldname": name, val})
			.then(noerror => {
				if( noerror ){
					$(this).closest(".input-group").addClass("details-buttonshidden");
					inputcontainer.closest(".details-card").find(`.details-content .details-${name}`).text(val);
				}
				elcard.removeClass("details-card-disabled");
			});
		});
		
		inputcontainer.find(".datails-savebuttons .abortbutton").on("click", function(event){
			resetfield($(this).closest("[data-name]").data("name"));
			$(this).closest(".input-group").addClass("details-buttonshidden");
		});
		
		inputcontainer.find(".details-exitbutton").on("click", function(event){
			elcard.removeClass("details-editenabled");
			elcard.find(".details-content").show();
			inputcontainer.hide();
			inputcontainer.empty();
			
			details_showeditmessage(uid);
			
			details_showexpanders();
		});
		
		resetfield("title");
		resetfield("descr");
		resetfield("tags")
		
		var tagify = new Tagify(inputcontainer.find(`[name="tags"]`)[0],{
			"delimiters": " ",
			"maxTags": 20,
			"editTags": false,
			"pattern": /^[\w#]{3,30}$/,
			"transformTag": obj => {obj.value = obj.value.replace("#", "").toLowerCase()}
		})
		.on("input", event => {
			clearTimeout(details_tagstimer);
			details_tagstimer = setTimeout(() => {
				tagify.loading(true).dropdown.hide()
				$.get("/gallery/gettags", {
					"s": event.detail.value
				}, arr => {
					tagify.whitelist = arr;
					tagify.loading(false).dropdown.show(event.detail.value);
				}, "json");
			}, 500);
		})
		.on("change", event => {
			elcard.find(".details-tags").html(details_preparetags(tagify.value.map(obj => obj.value)));
		})
		.on("add", event => {
			details_send({
				imageid,
				"action": "addtag",
				"val": event.detail.data.value
			});
		})
		.on("remove", event => {
			details_send({
				imageid,
				"action": "deletetag",
				"val": event.detail.data.value
			});
		})
		 
	}
	
	function details_showeditmessage(uid){
		if( uid != window.ACCOUNTUID )
			return;
		
		var elcard = $(`#details-container .details-card[data-uid=${uid}]`);
		
		if( elcard.length && elcard.find(".details-title").text() == "" && elcard.find(".details-descr").text() == "" ){
			elcard.hide();
			$("#details-container").find(".details-editmessage").show();
		} else {
			elcard.show();
			$("#details-container").find(".details-editmessage").hide();
		}
	}
	
	function details_showexpanders(){
		$(".details-expander-container").each((i, v) => {
			var el = $(v);
			if( el.find("div:eq(0)").height() > el.height() + 10 ){
				el.closest(".details-card").find(".details-expander-button").show();
			}
		});
	}
	
	function details_preparetags(arr){
		return arr.map(v => `<a href="/gallery/tag/${v}">#${v}</a>`).join(" ");
	}
	
	function details_send(params){
		return new Promise((resolve, reject) => {
			$.post("/gallery/setimagedetails", params, result => {
				if( result == "ok" ){
					
					resolve(true);
				} else {
					alert("error: " + result);
					
					resolve(false);
				}
			});
		});
	}
	
	function modmenuclick(event){
		
		event.stopPropagation();
		
		var action = $(this).data("action");
		
		var el = $(this).closest(".galleryimage");
		
		if( action == "deleteimage" ){
			
			el.find(".deleteimage")
				.data("confirmflag", true)
				.data("deletedbymodflag", true)
				.click();
			
			return;
		}
		
		if( action == "galleryban" ){
			setTimeout(() => {
				 $(this).closest(".modmenu").find("[data-action=deleteimage]").click();
			}, 1);
		}
		
		$.post("/gallery/modaction", {
			action,
			"imageid": el.data("imageid")
		}, function(ret){
			if( ret == "ok" ){
				if( action == "restoreimage" || (action == "removefrompicks" && window.location.href.includes("/picks")) ){
					el.remove();
				}
			} else {
				alert("error");
			}
		});

		$(this).closest(".dropdown").find("[data-toggle=dropdown]").dropdown('hide');
	}
	
	
	infscroll.loadNextPage();
	
	
	

	

});

window.deleteimage = function(event, imageid){
	
	event.stopPropagation();
	
	var el = $(event.target).closest(".deleteimage");
	
	if( !el.data("confirmflag")  ){
		el.data("confirmflag", true);
		el.find(".confirmicon").show();

		return;
	}
	
	el.data("confirmflag", false);
	el.find(".confirmicon").hide();
	el.hide();
	
	$.post("/gallery/deleteimage", {
		imageid,
		"deletedbymodflag": el.data("deletedbymodflag")
	}, function(obj){
		if( !obj.error ){
			el.closest(".grid-item").remove();
		} else {
			alert("error");
			el.show();
		}
	}, "json");
	
	if( el.data("deletedbymodflag") ){
		el.data("deletedbymodflag", false);
	}
}

window.rateimage = function(event, imageid, rating){
	
	event.stopPropagation();
	
	if( $(event.target).closest(".imagerating").find(".ratingbutton-voted").length > 0 ){
		
		return;
	}
	
	$(event.target).closest(".ratingbutton").addClass("ratingbutton-voted");
	localstorage_set(`r${imageid}`, rating);
	
	$.post("/gallery/rateimage", {
		imageid,
		rating
	}, function(ret){
		if( ret == "ok" ){
			var el = $(event.target).closest(".ratingbutton").find("span");
				
			el.text(el.text() ? Number(el.text()) + 1 : "1") ;
		}
	});
}

window.viewimage = function(event){
	if( $(event.target).is("a") || $(event.target).closest("a").length )
		return;
	
	var el = $(event.target).closest(".galleryimage").find("img");

	window.gallery = new PhotoSwipe( $(".pswp")[0], PhotoSwipeUI_Default, [{
        src: el.attr("src").replace("s.jpg", ".jpg"),
        w: 0,
        h: 0
    }], {
		history: false
	});
	
	
	gallery.listen('gettingData', function(index, item) {
        if (item.w < 1 || item.h < 1) { 
        var img = new Image(); 
        img.onload = function() {
        item.w = this.width;
        item.h = this.height;
           gallery.invalidateCurrItems();
           gallery.updateSize(true);
        }
    img.src = item.src;
    }
	});
	
	gallery.listen("close", function(){
		if( window.location.pathname.includes("/img/") && !imageidparam ){
			window.history.back();
		}
	});
	
	if( !window.location.pathname.includes("/img/") ){
		window.history.pushState({"name": "viewimage", "imageid": $(event.target).closest(".galleryimage").data("imageid")}, "Gallery Image", "/gallery/img/" + $(event.target).closest(".galleryimage").data("imageid"))
	}
	
	
	$("#sharebuttons a:not(.excl)").each(function(k, v){
		
		$(v).attr("href", $(v).data("href")
			.replace("%url%", encodeURIComponent(window.location.href))
			.replace("%text%", encodeURIComponent($(event.target).closest(".galleryimage").find(".playername").text()))
			.replace("%imagefile%", encodeURIComponent(window.location.origin + "/" + el.attr("src").replace("s.jpg", ".jpg"))))
	})
	
	if( !window.navigator.languages.find(v => v.toUpperCase().includes("RU")) ){
		$('[aria-label="VK"]').hide();
	}
	
	$("#imagelink").attr("href", "/gallery/img/" + $(event.target).closest(".galleryimage").data("imageid"));
	
	currentimageid = $(event.target).closest(".galleryimage").data("imageid");
	
	gallery.init();
}

window.reportimage = function(event){
	event.preventDefault();
	event.stopPropagation();
	
	
	
	$.post("/reportgalleryimage", {
		"imageid": currentimageid || imageidparam
	}, function(obj){
		
		setTimeout(function(){
			
			if( window.gallery ){
				window.gallery.close();
			} else {
				window.location = "/gallery";
			}
			
		}, 1000);
		
		alert(obj.error || "Image was reported");
		
	}, "json");
	
}

window.getplayernames = function(imagedata){
	var s = imagedata.deletedflag ? "" : `<a href="/gallery/?uid=${imagedata.uid}">${imagedata.name}</a>`;
	
	try {
		var obj = imagedata.accplayernames ? JSON.parse(imagedata.accplayernames) : {};
		
		imagedata.accplayernamesobj = obj;
		
		for (var k in obj) {
			s += `, <a href="/gallery/?uid=${k}">${obj[k]}</a>`;
		}
		
		s += `<span>, ${JSON.parse(imagedata.guestplayernames).join(", ")}</span>`;
	} catch(err) {}		
	
	if( imagedata.deletedflag ){
		s = s.substring(2)
	}
	
	return s;
}

window.getplayernames_rand = function(imagedata){
	var s = "";
	
	try {
		
		var obj = imagedata.accplayernames ? JSON.parse(imagedata.accplayernames) : {};
		imagedata.accplayernamesobj = obj;
		
		if( !imagedata.deletedflag ){
			obj[imagedata.uid] = imagedata.name;
		}
		
		var keys = Object.keys(obj);
		shuffleArray(keys);
		
		for( var i = 0; i < keys.length; i++ ){
			var k = keys[i];
			s += `<a href="/gallery/?uid=${k}">${obj[k]}</a>, `;
		}
		
		if( imagedata.guestplayernames ){
			var arr = JSON.parse(imagedata.guestplayernames);
			shuffleArray(arr);
			
			s += `<span>${arr.join(", ")}</span>`;
		} else {
			s = s.substring(0, s.length - 2);
		}
	} catch(err) {}		
	
	return s;
}

window.localstorage_get = function(k){
		
		try {
			
			return localStorage.getItem(k);
			
		} catch(err) {}
	}
	
window.localstorage_set = function(k, v){
	
	try {
		
		return localStorage.setItem(k, v);
		
	} catch(err) {}
}

window.shuffleArray = function(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

